<template>
  <section id="filter-pills-container" :style="styles"
    v-if="selectedColorOptions.length || selectedFilterOptions.length">
    <hr />
    <div class="filter-pills">
      <filter-pill v-for="color in selectedColorOptions" :key="color.code" :pill-name="color.name"
        @remove-filter="toggleColorFilter(color.code)" />
      <filter-pill v-for="filter in selectedFilterOptions" :key="filter.code" :pill-name="filter.name"
        @remove-filter="removeFilter(filter)" />
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import FilterPill from "./FilterPill";

export default {
  name: 'FilterPills',

  components: {
    FilterPill
  },

  data() {
    return {
      styles: {
        top: `${document.querySelector("div.mobile-head-wrapper").clientHeight}px`
      }
    };
  },

  computed: {
    ...mapGetters([
      'selectedFilterOptions',
      'selectedColorOptions',
      'allParentFilters'
    ])
  },

  mounted() {
    $(window).on('resize', () => {
      if (document.querySelector("div.mobile-head-wrapper").clientHeight === 0) {
        this.styles.top = '109px';
      } else {
        this.styles.top = `${document.querySelector("div.mobile-head-wrapper").clientHeight}px`;
      }
    });
  },

  methods: {
    ...mapActions([
      'toggleFilterOption',
      'toggleColorFilter'
    ]),

    removeFilter(clickedFilter) {
      let filterParent = null;

      if (!clickedFilter.parent_category_refs) {
          filterParent = clickedFilter;
      } else {
        for (let ref of clickedFilter.parent_category_refs) {
          filterParent = this.allParentFilters.find(filter => filter.id.toString() === ref.id.toString());
          if (filterParent) break;
        }
      }

      this.toggleFilterOption({ clickedFilter, filterParent });
    }
  }
}
</script>

<style lang="scss">
#filter-pills-container {
  margin-bottom: 10px;
  position: sticky;
  top: 149px;
  z-index: 10;
  margin-left: -2px;

  hr {
    border-top: 1px solid #bcbcbc;
    margin: 0;
  }

  .filter-pills {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
}

@media (max-width: 510px) {
  #filter-pills-container {
    top: 117px;
  }
}
</style>
